import {createAction} from 'redux-actions'

export const fetch = createAction('PGM/TYPES/FETCH')
export const receive = createAction('PGM/TYPES/RECEIVE')
